module.exports = __webpack_public_path__ + "static/media/devo.755e0f95.png";